import React, { useEffect } from 'react';
import { Card, Layout } from 'antd';
import { useRemark } from 'react-remark';
import { readFileSync } from 'fs';

const Changelog = () => {
  const [reactContent, setMarkdownSource] = useRemark();

  useEffect(() => {
    const getChangelog = async () => {
      var c = await readFileSync('changelog.md', 'utf8');
      setMarkdownSource(c);
    };
    getChangelog();
  }, []);

  return (
    <>
      {
        <style
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: `
              header.ant-app-header.ant-layout-header {
                background-color: #161616;
                display: block !important;
              }
              .ant-app-header-actions .ant-btn i.icon {
                color: #d0d0d0;
                display: none !important;
              }
              .ant-app-header-actions .ant-btn i.icon:hover {
                color: #ffffff;
              }
              .ant-app-header-actions .ant-btn:hover i.icon,
              .ant-app-header-actions .ant-btn:focus i.icon {
                padding: 0px;
                color: #ffffff;
                background-color: transparent;
                border-color: transparent;
              }

              .changelog{
                margin: 20px;
              }

              ul {
                list-style-type: circle;
              }

              li{
                margin: 0 0 0 20px;
              }a
            `,
          }}
        />
      }
      <Layout>
        <div className='changelog'>
          <Card>
            <h1>Changelog</h1>
            {reactContent}
          </Card>
        </div>
      </Layout>
    </>
  );
};

export default Changelog;
